import {ACTION_TYPES} from 'constants/ActionTypes';
import {Products} from 'api';

export function openPopupProductDetail(productID) {
  return dispatch => {
    dispatch({
      type: ACTION_TYPES.DISPLAY_LOADING_POPUP,
      isLoading: true
    });
    Products.actions.product.request({id: productID}).then(response => {
      dispatch({
        type: ACTION_TYPES.OPEN_POPUP_PRODUCT_DETAIL,
        isOpen: true,
        scrollY: window.scrollY,
        data: response.data
      });
      dispatch({
        type: ACTION_TYPES.DISPLAY_LOADING_POPUP,
        isLoading: false
      });
    });
  };
}

export function closePopupProductDetail() {
  return dispatch => {
    dispatch({
      type: ACTION_TYPES.CLOSE_POPUP_PRODUCT_DETAIL,
      isOpen: false,
      data: null
    });
  };
}

export function openSendRequestForm(id) {
  return dispatch => {
    dispatch({
      type: ACTION_TYPES.OPEN_REQUEST_FORM_PRODUCT,
      isOpenForm: true,
      productId: id
    });
  };
}

export function closeSendRequestForm() {
  return dispatch => {
    dispatch({
      type: ACTION_TYPES.CLOSE_REQUEST_FORM_PRODUCT,
      isOpenForm: false
    });
  };
}



// WEBPACK FOOTER //
// ./actions/product.js